// Video Hero Homepage JavaScript

class VideoHero {
  constructor() {
    this.video = document.querySelector('.video-hero__video');
    this.navItems = document.querySelectorAll('.video-hero__nav-item');
    this.init();
  }

  init() {
    if (this.video) {
      this.setupVideo();
    }
    this.setupNavigation();
  }

  setupVideo() {
    // Ensure video is muted for autoplay compliance
    this.video.muted = true;
    
    // Debug: Log video source
    console.log('Video source:', this.video.querySelector('source')?.src);
    
    // Handle video loading
    this.video.addEventListener('loadeddata', () => {
      console.log('Video loaded successfully');
      this.video.play().catch(e => {
        console.log('Video autoplay prevented:', e);
      });
    });

    // Handle video load start
    this.video.addEventListener('loadstart', () => {
      console.log('Video loading started');
    });

    // Handle video can play
    this.video.addEventListener('canplay', () => {
      console.log('Video can play');
    });

    // Handle video errors
    this.video.addEventListener('error', (e) => {
      console.error('Video error:', e);
      console.error('Video error details:', this.video.error);
      this.showFallback();
    });

    // Handle video load timeout
    setTimeout(() => {
      if (this.video.readyState === 0) {
        console.warn('Video failed to load within 10 seconds');
        this.showFallback();
      }
    }, 10000);

    // Pause video when page is not visible (performance)
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        this.video.pause();
      } else {
        this.video.play().catch(e => {
          console.log('Video play prevented:', e);
        });
      }
    });
  }

  setupNavigation() {
    this.navItems.forEach(item => {
      item.addEventListener('click', (e) => {
        // Add click animation
        item.style.transform = 'scale(0.95)';
        setTimeout(() => {
          item.style.transform = '';
        }, 150);
      });

      // Add keyboard navigation
      item.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          item.click();
        }
      });
    });
  }

  showFallback() {
    console.log('Showing fallback content');
    // Show fallback content if video fails to load
    const fallback = document.createElement('div');
    fallback.className = 'video-hero__fallback';
    fallback.style.cssText = `
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(135deg, #000 0%, #333 100%);
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-size: 1.5rem;
      z-index: 1;
    `;
    fallback.textContent = 'Welcome to Le Gaz Cafe - Video loading...';
    
    if (this.video && this.video.parentNode) {
      this.video.parentNode.appendChild(fallback);
    }
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new VideoHero();
});

// Handle page transitions for SPA-like behavior
document.addEventListener('shopify:section:load', () => {
  new VideoHero();
});
